import UncheckedJsonRpcSigner from "./signer";
import { ethers } from "ethers";
import BigBeyondABI from "./BigBeyondABI.json";

const BigBeyond_ADDRESS =
  process.env.REACT_APP_CONTRACT_ADDRESS ||
  "0x6a1F2511D2dEc3E58D654E290fCf0e5F536D15B0";

export function isAddress(value) {
  try {
    ethers.utils.getAddress(value);
    return true;
  } catch {
    return false;
  }
}

export function getProviderOrSigner(library, account) {
  return account
    ? new UncheckedJsonRpcSigner(library.getSigner(account))
    : library;
}

// account is optional
export function getContract(address, ABI, library, account) {
  if (!isAddress(address) || address === ethers.constants.AddressZero) {
    throw Error(`Invalid 'address' parameter '${address}'.`);
  }

  return new ethers.Contract(
    address,
    ABI,
    getProviderOrSigner(library, account)
  );
}

export function getBeyondContract(library, account) {
  return getContract(BigBeyond_ADDRESS, BigBeyondABI, library, account);
}
